import { MdsIconKind } from "@/design-system/components/icon";
import { MDSSidebarSectionHeader } from "@/mds/components/sidebar/sidebar-section-header";
import styled from "@emotion/styled";
import { useState } from "react";

export const SideBar = () => {
  const [isNotesExpanded, setIsNotesExpanded] = useState(false);
  return (
    <StyledSidebar>
      <MDSSidebarSectionHeader
        label="Notes"
        defaultIconKind={MdsIconKind.Notebook}
        isExpanded={isNotesExpanded}
        onPress={() => setIsNotesExpanded(!isNotesExpanded)}
      />
      <MDSSidebarSectionHeader
        label="Collections"
        defaultIconKind={MdsIconKind.Collection}
        isExpanded={isNotesExpanded}
        onPress={() => setIsNotesExpanded(!isNotesExpanded)}
      />
    </StyledSidebar>
  );
};

const StyledSidebar = styled.div`
  display: inline-flex;
  padding: ${({ theme }) => theme.spacing["0"]} ${({ theme }) => theme.spacing["3"]};
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing["0"]};
  flex-shrink: 0;
`;
